import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
  alpha,
  Autocomplete,
} from "@mui/material";
import {
  Edit as EditIcon,
  Add as AddIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import api from "../../services/api";

const AutoDeInfracaoAnalista = () => {
  const theme = useTheme();

  const tipoOptions = [
    { value: 0, label: "Multa" },
    { value: 1, label: "Advertência" },
  ];

  const [descricao, setDescricao] = useState("");
  const [tipo, setTipo] = useState(0);
  const [empreendimento, setEmpreendimento] = useState(null);
  const [empreendimentoInputValue, setEmpreendimentoInputValue] = useState("");
  const [empreendimentos, setEmpreendimentos] = useState([]);
  const [carregandoEmpreendimentos, setCarregandoEmpreendimentos] =
    useState(false);
  const [valor, setValor] = useState("");
  const [status, setStatus] = useState(0);
  const [vencimento, setVencimento] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [autoId, setAutoId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [autos, setAutos] = useState([]);
  const [loadingLista, setLoadingLista] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginacao, setPaginacao] = useState(null);
  const [filtros, setFiltros] = useState({
    numero: "",
    tipo: "",
    dataInicial: "",
    dataFinal: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);

  const statusOptions = [
    { value: 0, label: "Em Aberto" },
    { value: 1, label: "Pago" },
    { value: 2, label: "Em Recurso" },
    { value: 3, label: "Vencido" },
    { value: 4, label: "Cancelado" },
    { value: 5, label: "Suspenso" },
    { value: 6, label: "Parcelado" },
    { value: 7, label: "Dívida Ativa" },
    { value: 8, label: "Em Análise" },
  ];

  const buscarEmpreendimentos = async (nome) => {
    if (!nome || nome.trim().length < 3) {
      setEmpreendimentos([]);
      return;
    }

    setCarregandoEmpreendimentos(true);
    try {
      const response = await api.get("Empreendimento/filtrar", {
        params: { nome, descricao: null },
      });
      setEmpreendimentos(response.data?.data || []);
    } catch (err) {
      console.error("Erro ao buscar empreendimentos:", err);
      setEmpreendimentos([]);
    } finally {
      setCarregandoEmpreendimentos(false);
    }
  };

  const carregarAutos = async () => {
    setLoadingLista(true);
    try {
      const params = new URLSearchParams();
      if (filtros.numero) params.append("numero", filtros.numero);
      if (filtros.tipo) params.append("tipo", filtros.tipo);
      if (filtros.dataInicial)
        params.append("data_inicial", filtros.dataInicial);
      if (filtros.dataFinal) params.append("data_final", filtros.dataFinal);
      params.append("page_number", paginaAtual);
      params.append("page_size", pageSize);

      const response = await api.get(
        `/AutoDeInfracao/filtrar?${params.toString()}`,
      );
      setAutos(response.data.data || []);
      setPaginacao(response.data.pagination || null);
      setError(null);
    } catch (err) {
      setError(
        err.response?.data?.message || "Erro ao carregar autos de infração.",
      );
      setAutos([]);
    } finally {
      setLoadingLista(false);
    }
  };

  const handleBuscar = (e) => {
    e.preventDefault();
    setPaginaAtual(1);
    carregarAutos();
  };

  useEffect(() => {
    carregarAutos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaAtual, pageSize]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleNovoClick = () => {
    setIsEdit(false);
    setDescricao("");
    setTipo(0);
    setEmpreendimento(null);
    setEmpreendimentoInputValue("");
    setValor("");
    setStatus(0);
    setVencimento("");
    setAutoId(null);
    setError(null);
    setDialogOpen(true);
  };

  const handleEditarClick = (auto) => {
    setIsEdit(true);
    setDescricao(auto.descricao);
    setTipo(auto.tipo);
    setEmpreendimento(
      auto.nomeEmpreendimento
        ? { id: auto.empreendimentoId, nome: auto.nomeEmpreendimento }
        : null,
    );
    setEmpreendimentoInputValue("");
    setValor(auto.valor ? auto.valor.toString() : "");
    setStatus(auto.status);
    setVencimento(auto.vencimento ? auto.vencimento.split("T")[0] : "");
    setAutoId(auto.data);
    setError(null);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDescricao("");
    setTipo(0);
    setEmpreendimento(null);
    setEmpreendimentoInputValue("");
    setValor("");
    setStatus(0);
    setVencimento("");
    setAutoId(null);
    setError(null);
  };

  const handleValorChange = (e) => {
    const valor = e.target.value;
    const apenasNumeros = valor.replace(/\D/g, "");
    if (apenasNumeros === "") {
      setValor("");
    } else {
      const valorFloat = (parseInt(apenasNumeros) / 100).toFixed(2);
      setValor(valorFloat);
    }
  };

  const handleSalvar = async () => {
    setLoading(true);
    setError(null);

    const erros = [];

    if (!descricao || descricao.trim() === "") {
      erros.push("Descrição é obrigatória");
    }

    if (tipo === null || tipo === "") {
      erros.push("Tipo é obrigatório");
    }

    if (!empreendimento || !empreendimento.id) {
      erros.push("Empreendimento é obrigatório");
    }

    if (!valor || parseFloat(valor) <= 0) {
      erros.push("Valor deve ser maior que zero");
    }

    if (status === null || status === "") {
      erros.push("Status é obrigatório");
    }

    if (!vencimento || vencimento.trim() === "") {
      erros.push("Data de vencimento é obrigatória");
    }

    if (erros.length > 0) {
      setError(erros.join("; "));
      setLoading(false);
      return;
    }

    try {
      const payload = {
        descricao: String(descricao),
        tipo,
        empreendimentoId: empreendimento?.id || null,
        valor: valor ? parseFloat(valor) : 0,
        status,
        vencimento: vencimento || null,
      };

      if (isEdit && autoId) {
        payload.id = autoId;
        await api.put("AutoDeInfracao", payload);
        setSuccess("Auto de Infração atualizado com sucesso!");
      } else {
        await api.post("AutoDeInfracao", payload);
        setSuccess("Auto de Infração criado com sucesso!");
      }

      handleDialogClose();
      setPaginaAtual(1);
      carregarAutos();
    } catch (err) {
      console.error("Erro ao salvar auto de infração:", err);
      setError(
        err.response?.data?.message || "Erro ao salvar Auto de Infração",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: { xs: 2, md: 4 },
        mb: { xs: 2, md: 4 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          mb: { xs: 3, md: 4 },
          display: "flex",
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="h4"
            component="h1"
            fontWeight="bold"
            color="primary.main"
            sx={{ fontSize: { xs: "1.35rem", sm: "1.75rem", md: "2.125rem" } }}
          >
            Auto de Infração
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleNovoClick}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          Novo Auto
        </Button>
      </Box>

      {success && (
        <Alert
          severity="success"
          sx={{ mb: 3 }}
          onClose={() => setSuccess(null)}
        >
          {success}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          mb: 3,
          borderRadius: 2,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Filtros
        </Typography>
        <form onSubmit={handleBuscar}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Número"
                name="numero"
                value={filtros.numero}
                onChange={handleFiltroChange}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select
                  name="tipo"
                  value={filtros.tipo}
                  onChange={handleFiltroChange}
                  label="Tipo"
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="MULTA">Multa</MenuItem>
                  <MenuItem value="ADVERTENCIA">Advertência</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Data Inicial"
                name="dataInicial"
                type="date"
                value={filtros.dataInicial}
                onChange={handleFiltroChange}
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Data Final"
                name="dataFinal"
                type="date"
                value={filtros.dataFinal}
                onChange={handleFiltroChange}
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 2, display: "flex", justifyContent: { xs: "stretch", sm: "flex-end" } }}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              startIcon={<SearchIcon />}
              disabled={loadingLista}
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              {loadingLista ? "Buscando..." : "Buscar"}
            </Button>
          </Box>
        </form>
      </Paper>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          overflowX: "auto",
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        }}
      >
        <Table>
          <TableHead
            sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.05) }}
          >
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Número</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Descrição</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Tipo</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Valor (R$)</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Vencimento</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingLista ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : autos.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  Nenhum auto de infração encontrado
                </TableCell>
              </TableRow>
            ) : (
              autos.map((auto) => (
                <TableRow
                  key={auto.data}
                  sx={{
                    "&:hover": {
                      backgroundColor: alpha(theme.palette.primary.main, 0.05),
                    },
                  }}
                >
                  <TableCell>{auto.data}</TableCell>
                  <TableCell>{auto.descricao}</TableCell>
                  <TableCell>
                    {tipoOptions.find((t) => t.value === auto.tipo)?.label ||
                      auto.tipo}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "inline-block",
                        px: 2,
                        py: 0.5,
                        borderRadius: 1,
                        backgroundColor:
                          auto.status === 0
                            ? alpha(theme.palette.warning.main, 0.1)
                            : auto.status === 1
                              ? alpha(theme.palette.success.main, 0.1)
                              : auto.status === 4
                                ? alpha(theme.palette.error.main, 0.1)
                                : alpha(theme.palette.info.main, 0.1),
                        color:
                          auto.status === 0
                            ? theme.palette.warning.main
                            : auto.status === 1
                              ? theme.palette.success.main
                              : auto.status === 4
                                ? theme.palette.error.main
                                : theme.palette.info.main,
                      }}
                    >
                      {statusOptions.find((s) => s.value === auto.status)
                        ?.label || auto.status}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {auto.valor
                      ? `R$ ${parseFloat(auto.valor)
                          .toFixed(2)
                          .replace(".", ",")}`
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {auto.vencimento
                      ? (() => {
                          const [ano, mes, dia] = auto.vencimento.split("-");
                          return `${dia}/${mes}/${ano}`;
                        })()
                      : "-"}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => handleEditarClick(auto)}
                      title="Editar"
                      aria-label={`Editar auto ${auto.data}`}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {paginacao && (
        <Paper
          elevation={0}
          sx={{
            border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            borderTop: "none",
            p: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            backgroundColor: alpha(theme.palette.primary.main, 0.02),
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Mostrando{" "}
            {autos.length > 0
              ? (paginacao.pageNumber - 1) * paginacao.pageSize + 1
              : 0}{" "}
            a{" "}
            {Math.min(
              paginacao.pageNumber * paginacao.pageSize,
              paginacao.totalCount,
            )}{" "}
            de {paginacao.totalCount} registros
          </Typography>

          <Pagination
            count={paginacao.totalPages}
            page={paginaAtual}
            onChange={(_, page) => setPaginaAtual(page)}
            color="primary"
          />

          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="body2">Registros por página:</Typography>
            <Select
              value={pageSize}
              onChange={(e) => {
                setPageSize(e.target.value);
                setPaginaAtual(1);
              }}
              size="small"
              sx={{ minWidth: 70 }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
          </Box>
        </Paper>
      )}

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { m: { xs: 2, sm: 3 } },
        }}
      >
        <DialogTitle>
          {isEdit ? "Editar Auto de Infração" : "Novo Auto de Infração"}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            fullWidth
            label="Descrição"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            margin="normal"
            multiline
            rows={3}
            size="small"
          />

          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Tipo</InputLabel>
            <Select
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
              label="Tipo"
            >
              {tipoOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Autocomplete
            fullWidth
            disabled={isEdit}
            options={empreendimentos}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option?.nome || ""
            }
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            value={empreendimento}
            onChange={(_, newValue) => setEmpreendimento(newValue)}
            inputValue={empreendimentoInputValue}
            onInputChange={(_, newInput) => {
              setEmpreendimentoInputValue(newInput);
              buscarEmpreendimentos(newInput);
            }}
            loading={carregandoEmpreendimentos}
            noOptionsText={
              empreendimentoInputValue &&
              empreendimentoInputValue.trim().length >= 3
                ? "Nenhum empreendimento encontrado"
                : "Digite 3 ou mais letras"
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Empreendimento"
                placeholder="Digite o nome do empreendimento"
                margin="normal"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {carregandoEmpreendimentos ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />

          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Valor (R$)"
            value={valor}
            onChange={handleValorChange}
            margin="normal"
            placeholder="R$ 0,00"
            size="small"
            inputProps={{
              inputMode: "numeric",
            }}
          />

          <TextField
            fullWidth
            label="Data de Vencimento"
            value={vencimento}
            onChange={(e) => setVencimento(e.target.value)}
            margin="normal"
            type="date"
            InputLabelProps={{ shrink: true }}
            size="small"
          />
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 1, sm: 0 },
            "& > button": { width: { xs: "100%", sm: "auto" } },
          }}
        >
          <Button onClick={handleDialogClose}>Cancelar</Button>
          <Button
            onClick={handleSalvar}
            variant="contained"
            disabled={loading || !descricao}
          >
            {loading ? <CircularProgress size={24} /> : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AutoDeInfracaoAnalista;
